
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import BaseUpload from './BaseUpload.vue'
// @ts-ignore
import CircleProgress from 'vue-circleprogressbar'
import FileItem from './FileItem.vue'
import { creatMaterialFileSymlink } from '@/api/placeOrder'
import { handleUrl } from '../../helper'
import { IFileList, IOrderForm } from '@/types/placeOrderTypes'
import { FileTypes, UploadService } from './fileOperations'
import { Action, Getter } from 'vuex-class'
import { IServiceMap } from '@/business/BusinessFormData'

@Component({
  components: {
    BaseUpload,
    CircleProgress,
    FileItem,
  },
})
export default class WordUpload extends Vue {
  @Action('setOrderId') setOrderId: any
  @Getter('user') user: any

  @Prop({ default: false }) checking!: boolean
  @Prop({ default: false }) uploading!: boolean
  @Prop({ default: () => [] }) wordList!: any[]
  @Prop({}) formInfo!: IServiceMap
  @Prop() form!: IOrderForm
  @Prop({ required: true }) order_id!: string
  @Prop() files!: IFileList[]
  @Prop() screenForm!: Function
  @Prop() checkForm!: Function
  @Prop() selectFileType!: number

  title = 'Word文件'

  get WordToFbd() {
    return this.formInfo.formData.service_content == 11 || this.formInfo.formData.service_content == 16
  }

  get WordToPpt() {
    return this.formInfo.formData.service_content == 18
  }

  get AIEdit() {
    return this.formInfo.formData.service_content == 30 || this.formInfo.formData.service_content == 31
  }

  get showMoreButton() {
    return !this.AIEdit && !this.WordToPpt && !this.WordToFbd
  }

  get accept() {
    return this.WordToFbd ? '.doc,.docx' : '.docx'
  }

  get multiple() {
    return !this.WordToFbd && !this.AIEdit
  }

  @Emit('update:wordList')
  updateWordList(list: any[]) {
    return list
  }

  @Emit('upload-start')
  setUploading(value: boolean) {
    return value
  }

  async handleFileSelected(files: any[]) {
    if (files.length) {
      this.updateWordList([...this.wordList, ...files])
    }
  }

  selectMore() {
    ;(this.$refs.baseUpload as any).selectFile()
  }

  async startUpload() {
    await UploadService.uploadFiles({
      context: this,
      fileList: this.wordList,
      fileType: FileTypes.WORD,
      screenForm: this.screenForm,
      checkForm: this.checkForm,
      filterCondition: (item, form) =>
        item.word && !form.material.oss_word_files.filter((word: any) => word!.name === item.word!.name).length,
      handleExistingFile: async (item, path, form) => {
        if (!form.material.oss_word_files) form.material.oss_word_files = []

        const symlinkData = await creatMaterialFileSymlink({
          ticket_id: this.order_id,
          origin_path: path,
          name: item.word!.name,
          path_alias: 'content_word',
        })

        form.material.oss_word_files.push({
          path: handleUrl(symlinkData.symlink_path),
          is_del: false,
          extension: 'docx',
          name: item.word!.name,
          md5: item.md5,
        })
      },
      afterUpload: (item, symlinkData, form) => {
        if (!form.material.oss_word_files) form.material.oss_word_files = []

        form.material.oss_word_files.push({
          path: symlinkData.symlink_path,
          is_del: false,
          extension: 'docx',
          name: item.word!.name,
          md5: item.md5,
        })
      },
      onUploadFinished: async fileList => {
        if (this.WordToFbd) {
          let projects = this.form.xdoc_planning || []

          if (projects.length) {
            projects[0].origin_files = [
              {
                index: 0,
                type: 1,
                name: fileList[0].word?.name || '',
                selected: false,
              },
            ]
          } else {
            projects = [
              {
                name: this.form.alias + '-图书',
                config: {
                  fbd_type: 0,
                  delivery: 9,
                },
                origin_files: [
                  {
                    index: 0,
                    type: 1,
                    name: fileList[0].name || fileList[0].word?.name || '',
                    selected: false,
                  },
                ],
              },
            ]
          }
          this.$set(this.form, 'xdoc_planning', projects)
        } else if (this.AIEdit) {
          let projects = this.form.xdoc_planning || []

          if (projects.length) {
            projects[0].origin_files?.push({
              index: 0,
              type: 1,
              name: fileList[0].word?.name || '',
              selected: false,
            })
          } else {
            projects = [
              {
                name: this.form.alias,
                config: {
                  delivery: 1,
                  word_type: 'teacher',
                },
                origin_files: [
                  {
                    index: 0,
                    type: 1,
                    name: fileList[0].word?.name || '',
                    word_name: fileList[0].word?.name || '',
                  },
                ],
                is_open_create: true,
              },
            ]
          }
          this.$set(this.form, 'xdoc_planning', projects)
        } else if (this.WordToPpt) {
          let projects = this.form.xdoc_planning || []

          if (projects.length) {
            projects[0].origin_files?.push({
              index: 0,
              type: 1,
              name: fileList[0].word?.name || '',
              selected: false,
            })
          } else {
            projects = [
              {
                name: this.form.alias,
                config: {
                  delivery: 15,
                  word_type: 'paper',
                  fbd_type: 0,
                },
                origin_files: [
                  {
                    index: 0,
                    type: 1,
                    name: fileList[0].word?.name || '',
                    word_name: fileList[0].word?.name || '',
                  },
                ],
              },
            ]
          }
          this.$set(this.form, 'xdoc_planning', projects)
        }
      },
    })
  }
  removeWordFile(name: string) {
    const wordIndex = this.files.findIndex(item => item.word && item.word.name === name)
    const ListIndex = this.wordList.findIndex(item => item.word && item.word.name === name)
    this.files.splice(wordIndex, 1)
    this.wordList.splice(ListIndex, 1)
    if (
      this.form &&
      this.form.material.oss_word_files &&
      this.form.material.oss_word_files.filter(item => item.name === name).length
    ) {
      this.form.material.oss_word_files.splice(ListIndex, 1)
    }
  }
}
